import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ValueAddFourTypeAdapter } from './dto/value-addition-four.adapter';
import { ValueAdditionFourType } from './value-addition-four.entity';
import { ValueAddition4TypesController } from './value-addition4-types.controller';
import { ValueAddition4TypesService } from './value-addition4-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ValueAdditionFourType]),
  ],
  controllers: [ValueAddition4TypesController],
  providers: [ValueAddition4TypesService,ValueAddFourTypeAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ValueAddition4TypesService]
})
export class ValueAddition4TypesModule {}
